import { jsx as f } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.es.js";
import { SvgIcon } from "@mui/material";
function n(r) {
  return /* @__PURE__ */ f(SvgIcon, { ...r, children: /* @__PURE__ */ f("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M17.49 8.86011L12.02 12L6.52002 8.86011C5.58002 8.33011 5 8.00001 5 6.26001V4.5C5 3.67 5.67 3 6.5 3H17.5C18.33 3 19 3.67 19 4.5V6.26001C19 8.00001 18.42 8.33011 17.49 8.86011ZM5 17.74V19.5C5 20.33 5.67 21 6.5 21H17.5C18.33 21 19 20.33 19 19.5V17.74C19 16 18.42 15.6699 17.49 15.1399L12.02 12L6.52002 15.1399C5.58002 15.6699 5 16 5 17.74Z", fill: "currentColor" }) }) });
}
export {
  n as HourglassSolid
};
//# sourceMappingURL=hourglass-solid.es.es.js.map
